import { useMutation, useQueryClient } from '@tanstack/react-query'
import { publishDraft } from '@/api/publish'
import { refreshAfterWrite } from '@/lib/refreshAfterWrite'

// Shared by every Publish entry point (AppShell's topbar, Diff &
// Validation's own button) - each caller holds its own modal open/
// release-note state and calls this independently, but they share the same
// query cache, so a publish fired from either place invalidates everywhere.
export function usePublishMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (releaseNote: string) => publishDraft(releaseNote),
    onSuccess: () => {
      refreshAfterWrite(queryClient, { kind: 'publish' })
    },
  })
}
